import React, { FC } from 'react';
import { makeStyles, Paper, Dialog } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

interface IStyles {
  isOverflow?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  eventModal: {
    // booking
    '& .MuiPopover-paper': {
      height: ({ isOverflow }: IStyles) => (isOverflow ? 'calc(100vh - 64px)' : 'auto'),
      top: '50% !important',
      transform: 'translateY(-50%) !important',
      'scrollbar-width': 'none',
      '-ms-overflow-style': 'none',

      '&::-webkit-scrollbar': {
        width: 0,
        height: 0,
      },
      [theme.breakpoints.down('xs')]: {
        height: ({ isOverflow }: IStyles) => (isOverflow ? '100vh' : 'auto'),
        maxHeight: '100%',
        maxWidth: '100%',
        left: '50% !important',
        transform: 'translateX(-50%) translateY(-50%) !important',
      },
    },
    // other
    '&>.MuiDialog-container>.MuiPaper-root': {
      height: ({ isOverflow }: IStyles) => (isOverflow ? 'calc(100vh - 64px)' : 'auto'),
      [theme.breakpoints.down('xs')]: {
        height: ({ isOverflow }: { isOverflow: boolean }) => (isOverflow ? '100vh' : 'auto'),
        maxHeight: '100%',
      },
    },
    '& .MuiDialog-paper': {
      margin: 'auto',
    },
  },
  eventModalPaper: {
    width: 424,
    maxWidth: '100%',
    minHeight: 150,
    height: '100%',
    position: 'relative',
  },
}));

interface IEventModal {
  isOpen: boolean;
  onClose: () => void;
  isOverflow?: boolean;
  children: JSX.Element;
}

const EventModal: FC<IEventModal> = ({ isOpen, onClose, isOverflow = false, children }) => {
  const classes = useStyles({ isOverflow });

  return (
    <Dialog
      className={classes.eventModal}
      open={isOpen}
      onClose={(event, reason) => (reason !== 'backdropClick' ? onClose() : null)}
      disableRestoreFocus
    >
      <Paper className={classes.eventModalPaper}>{children}</Paper>
    </Dialog>
  );
};

export default EventModal;
